import { render, staticRenderFns } from "./ImageDedupeItem.vue?vue&type=template&id=38b5b999&scoped=true"
import script from "./ImageDedupeItem.vue?vue&type=script&lang=js"
export * from "./ImageDedupeItem.vue?vue&type=script&lang=js"
import style0 from "./ImageDedupeItem.vue?vue&type=style&index=0&id=38b5b999&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b5b999",
  null
  
)

export default component.exports